import React, { useEffect, useRef } from 'react';

function QuestionLog({ log }) {
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [log]);

  return (
    <div className="question-log">
      <h3>Question Log</h3>
      <div className="log-entries">
        {log.length === 0 && (
          <p className="log-empty">No questions yet...</p>
        )}
        {log.map((entry, i) => (
          <div key={i} className="log-entry">
            <div className="log-question">
              <strong>{entry.asker}:</strong> {entry.question}
            </div>
            {entry.answer !== undefined && (
              <div className={`log-answer ${entry.answer}`}>
                {entry.answer.charAt(0).toUpperCase() + entry.answer.slice(1)}
              </div>
            )}
          </div>
        ))}
        <div ref={bottomRef} />
      </div>
    </div>
  );
}

export default QuestionLog;
